import { toast } from "react-toastify";
import "./index.scss";

const baseNotificationConfig = {
  position: "top-right",
  autoClose: 2000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: false,
  className: "theme-toast",
  bodyClassName: "theme-toast__body",
  progressClassName: "theme-toast__progress",
};

const getCSSVariable = (styles, variableName, fallback) => {
  const value = styles.getPropertyValue(variableName);
  return value ? value.trim() : fallback;
};

const getNotificationConfig = (variant = "default") => {
  if (typeof window === "undefined") {
    return {
      ...baseNotificationConfig,
      theme: "dark",
    };
  }

  const rootStyles = getComputedStyle(document.documentElement);
  const isLightTheme = document.body.classList.contains("theme-light");

  const defaultBackground = isLightTheme ? "#ffffff" : "#1E1E1E";
  const defaultText = isLightTheme ? "#000000" : "#ffffff";
  const defaultAccent = getCSSVariable(rootStyles, "--primary-color", "#FFEE20");

  const variantColorMap = {
    success: getCSSVariable(rootStyles, "--success-color", "#0B964B"),
    error: getCSSVariable(rootStyles, "--error-color", "#F20606"),
    warning: getCSSVariable(rootStyles, "--warning-color", "#FF9800"),
    info: getCSSVariable(rootStyles, "--info-color", defaultAccent),
    default: defaultAccent,
  };

  const accentColor = variantColorMap[variant] || variantColorMap.default;

  return {
    ...baseNotificationConfig,
    theme: isLightTheme ? "light" : "dark",
    style: {
      "--toast-bg-color": getCSSVariable(rootStyles, "--paper-color", defaultBackground),
      "--toast-text-color": getCSSVariable(rootStyles, "--text-primary", defaultText),
      "--toast-accent-color": accentColor,
      "--toast-shadow": isLightTheme
        ? "0 12px 30px rgba(0, 0, 0, 0.2)"
        : "0 12px 30px rgba(0, 0, 0, 0.5)",
    },
  };
};

const notifier = {
  default: (message) => toast(message, getNotificationConfig("default")),
  success: (message) => toast.success(message, getNotificationConfig("success")),
  error: (message) => toast.error(message, getNotificationConfig("error")),
  warning: (message) => toast.warn(message, getNotificationConfig("warning")),
  info: (message) => toast.info(message, getNotificationConfig("info")),
};

export default notifier;
